module.exports = __webpack_public_path__ + "img/phone.949457d5.svg";